import { render, staticRenderFns } from "./TrendDataLog.vue?vue&type=template&id=a0920036&scoped=true"
import script from "./TrendDataLog.vue?vue&type=script&lang=js"
export * from "./TrendDataLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0920036",
  null
  
)

export default component.exports